"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArmorNames = exports.WeaponNames = exports.SurNames = exports.FirstNames = exports.ClassNames = exports.RarityNames = exports.SlotNames = exports.ItemNames = exports.CraefterTypeNames = void 0;
var types_1 = require("./types");
var firstnames_1 = require("./lists/firstnames");
Object.defineProperty(exports, "FirstNames", { enumerable: true, get: function () { return firstnames_1.english; } });
var surnames_1 = require("./lists/surnames");
Object.defineProperty(exports, "SurNames", { enumerable: true, get: function () { return surnames_1.english; } });
var weaponnames_1 = __importDefault(require("./lists/weaponnames"));
exports.ArmorNames = weaponnames_1.default;
var weaponnames_2 = __importDefault(require("./lists/weaponnames"));
exports.WeaponNames = weaponnames_2.default;
exports.CraefterTypeNames = Object.freeze((_a = {},
    _a[types_1.Unknown] = "???",
    _a[types_1.CraefterTypes.WeaponCraefter] = "Weaponcräfter",
    _a[types_1.CraefterTypes.ArmorCraefter] = "Armorcräfter",
    _a[types_1.CraefterTypes.JewelCraefter] = "Jewelcräfter",
    _a[types_1.CraefterTypes.Alchemist] = "Alchemist",
    _a));
exports.ItemNames = Object.freeze((_b = {},
    _b[types_1.Unknown] = "???",
    _b[types_1.WeaponTypes.Sword] = "Sword",
    _b[types_1.WeaponTypes.JewelSword] = "Jewel Sword",
    _b[types_1.WeaponTypes.Knife] = "Knife",
    _b[types_1.WeaponTypes.JewelKnife] = "Jewel Knife",
    _b[types_1.WeaponTypes.Staff] = "Staff",
    _b[types_1.WeaponTypes.Wand] = "Wand",
    _b[types_1.WeaponTypes.JewelWand] = "Jewel Wand",
    _b[types_1.ArmorTypes.WoodenPlate] = "Wooden Plate",
    _b[types_1.ArmorTypes.WoodenChainmail] = "Wooden Chainmail",
    _b[types_1.ArmorTypes.MetalPlate] = "Metal Plate",
    _b[types_1.ArmorTypes.MetalChainmail] = "Metal Chainmail",
    _b[types_1.ArmorTypes.Woven] = "Woven",
    _b[types_1.ArmorTypes.JewelWoven] = "Jewel Woven",
    _b));
exports.SlotNames = Object.freeze((_c = {},
    _c[types_1.ArmorSlots.Head] = "Head",
    _c[types_1.ArmorSlots.Body] = "Body",
    _c[types_1.ArmorSlots.Legs] = "Legs",
    _c[types_1.ArmorSlots.Feet] = "Feet",
    _c));
exports.RarityNames = Object.freeze((_d = {},
    _d[types_1.Rarities.Common] = "Common",
    _d[types_1.Rarities.Rare] = "Rare",
    _d[types_1.Rarities.Epic] = "Epic",
    _d[types_1.Rarities.Legendary] = "Legendary",
    _d));
exports.ClassNames = Object.freeze((_e = {},
    _e[types_1.Classes.Novice] = "Novice",
    _e[types_1.Classes.Mage] = "Mage",
    _e[types_1.Classes.Swordsman] = "Swordsman",
    _e[types_1.Classes.Hunter] = "Hunter",
    _e));
